import React from 'react';
import { ApiContext } from './api-context';
import { usePromisifiedAction } from '../../../common/store/promisified-actions/use-promisified-action';
import { useOptimizedState } from './use-optimized-state';
import { getIsMobile, isLoggingEnabled, } from '../../../common/store/base-params/base-params-selectors';
import { useInitNavigationPrompt } from '../../hooks/use-navigation-prompt';
import { isControllerInitialized } from '../../is-controller-initialized';
export const WixCommentsApiProvider = (props) => {
    const { children, wcActions, wcActionsPromisified, wcState, wcRequestFullState, ...rest } = props;
    const state = useOptimizedState(wcState, 
    // In editor ooi there are cases when first thing received is wcState without the rest of comments props, so we provide default value
    wcRequestFullState ?? (() => { }));
    useInitNavigationPrompt({
        isMobile: isControllerInitialized(state) ? getIsMobile(state) : false,
    });
    const connectedActionsPromisified = (wcActionsPromisified &&
        isControllerInitialized(state) &&
        Object.keys(wcActionsPromisified).reduce((wrapped, actionName) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            wrapped[actionName] = usePromisifiedAction(wcActionsPromisified[actionName], state);
            return wrapped;
        }, {})) ||
        {};
    const actions = { ...wcActions, ...connectedActionsPromisified };
    if (typeof window !== 'undefined' && !window.wixComments) {
        // expose dev functionality
        window.wixComments = props.wcDevToolsApi;
    }
    const shouldLog = isControllerInitialized(state) && isLoggingEnabled(state);
    if (shouldLog) {
        console.log('[Api provider state, actions, props]', state, actions, props);
    }
    return React.createElement(ApiContext.Provider, { value: { ...rest, actions, state } }, children);
};
//# sourceMappingURL=api-provider.js.map